import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';

const Slider = ({ images }) => {
	return (
		<div className='slide-container border-2 rounded-lg'>
			<Slide transitionDuration={700} indicators easing='ease-in'>
				{images?.map(({ path }, idx) => (
					<div id={idx} className='grid justify-items-center'>
						<img
							alt={`Slider${idx}`}
							src={path}
						/>
                    </div>
				))}
			</Slide>		
        </div>
	);
};

export default Slider;
